<div class="container admin">
  <div class="row admin">
    <p class="admin-warning"><b>{{ 'admin.warning' | translate }}</b></p>
  </div>
  <app-admin-stammdaten-importgrund-new (reloadEntries)="gruende.reload()"></app-admin-stammdaten-importgrund-new>
  <div class="row admin">
    <div class="col-md-1.5 pl-0 mb-0"><p class="admin"><b>{{ 'admin.importgrund.column.de' | translate }}</b></p></div>
    <div class="col-md-1.5 pl-0 mb-0"><p class="admin"><b>{{ 'admin.importgrund.column.fr' | translate }}</b></p></div>
    <div class="col-md-1.5 pl-0 mb-0"><p class="admin"><b>{{ 'admin.importgrund.column.it' | translate }}</b></p></div>
    <div class="col-md-1 pl-0 mb-0"><p class="admin"><b>{{ 'admin.importgrund.column.sort' | translate }}</b></p></div>
    <div class="col-md-1 pl-0 mb-0"><p class="admin"><b>{{ 'admin.importgrund.column.kommentar' | translate }}</b></p></div>
    <div class="col-md-1 pl-0 mb-0"><p class="admin"><b>{{ 'admin.importgrund.column.zulassungsNrCh' | translate }}</b></p></div>
    <div class="col-md-1 pl-0 mb-0"><p class="admin"><b>{{ 'admin.importgrund.column.lieferEngpass' | translate }}</b></p></div>
    <div class="col-md-1 pl-0 mb-0"><p class="admin"><b>{{ 'admin.importgrund.column.aktiv' | translate }}</b></p></div>
    <div class="col-md-2.5 pl-0 mb-0"></div>
  </div>
  @for (set of gruende.value(); track set.id) {
    <div class="row admin"
         app-admin-stammdaten-importgrund-entry
         [set]="set"
         (reloadEntries)="gruende.reload()"
         (deleted)="onGrundDeleted(set.id)">
    </div>
  }
</div>
